<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 11.2c3.3-3 5-4.6 5-6.5C17 3.2 15.8 2 14.3 2A3 3 0 0 0 12 3a3 3 0 0 0-2.3-1A2.7 2.7 0 0 0 7 4.8c0 1.8 1.7 3.4 5 6.4m-.8.8c-3-3.3-4.6-5-6.5-5A2.7 2.7 0 0 0 2 9.8 3 3 0 0 0 3 12a3 3 0 0 0-1 2.3C2 15.8 3.3 17 4.8 17c1.8 0 3.4-1.7 6.4-5m1.6 0c3 3.3 4.6 5 6.5 5 1.5 0 2.7-1.2 2.7-2.7a3 3 0 0 0-1-2.3 3 3 0 0 0 1-2.3C22 8.2 20.8 7 19.3 7c-2 0-3.5 1.7-6.5 5m-.8.8c-3.3 3-5 4.6-5 6.5C7 20.8 8.3 22 9.8 22a3 3 0 0 0 2.2-1 3 3 0 0 0 2.3 1c1.5 0 2.7-1.2 2.7-2.7 0-2-1.7-3.5-5-6.5"
    />
  </svg>
</template>
